import React, { useState } from "react";
import AuthPage from "./AuthPage";
import { useEffect } from "react";
import ReferansKazancPage from "./ReferansKazancPage";
import EkibimPage from "./EkibimPage";
import ReferansAyarlar from "./ReferansAyarlar";







/* =====================================================

   REFERANS & EKİP YÖNETİMİ
   SINGLE FILE / PROFESSIONAL UI
===================================================== */

export default function ReferansDashboard() {
  const token = localStorage.getItem("user_token");

  // ✅ TÜM HOOKLAR EN ÜSTTE
const [active, setActive] = useState("dashboard");
const [earnings, setEarnings] = useState([]);

const [stats, setStats] = useState({
  withdrawable: 0,
  totalInvestment: 0,
  totalProfit: 0,
   refCode: "",
  pending: 0,
  teamCount: 0,
  teamVolume: 0,
});


useEffect(() => {
  if (!token) return;

  // Referans kodu
  fetch("https://api.haymestasarim.com/api/auth/my-ref", {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(r => r.json())
    .then(d => {
      setStats(s => ({
        ...s,
        refCode: d.ref_code,
      }));
    });

  // Takım üyeleri
fetch("https://api.haymestasarim.com/api/network/team/members", {
  headers: { Authorization: `Bearer ${token}` },
})
  .then(r => r.json())
  .then(d => {
    const list = Array.isArray(d) ? d : [];

    const count = list.length;

    // ✅ TAKIM HACMİ = HERKESİN PAKET TOPLAMI
    const volume = list.reduce(
      (t, m) => t + Number(m.paket_fiyati || 0),
      0
    );

    setStats(s => ({
      ...s,
      teamCount: count,
      teamVolume: volume, // 🔥 ARTIK DOLU
    }));
  })
  .catch(() => {
    setStats(s => ({
      ...s,
      teamCount: 0,
      teamVolume: 0,
    }));
  });

// 💼 TOPLAM YATIRIM (KENDİ PAKETLERİ)
fetch("https://api.haymestasarim.com/api/profile/investment", {
  headers: { Authorization: `Bearer ${token}` },
})
  .then(r => r.json())
  .then(d => {
    setStats(s => ({
      ...s,
      totalInvestment: Number(d.total_investment || 0),
    }));
  })
  .catch(() => {
    setStats(s => ({
      ...s,
      totalInvestment: 0,
    }));
  });



  // 🔥 REFERANS KAZANÇLARI (AYNI VERİ – DASHBOARD)
  fetch("https://api.haymestasarim.com/api/network/earnings", {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(r => r.json())

  .then(d => {
  const list = Array.isArray(d) ? d : [];

  const sum = (status) =>
    list
      .filter(e => e.status === status)
      .reduce((t, e) => t + Number(e.amount), 0);

  // ✅ TÜM BONUSLARIN TOPLAMI (status / level ayrımı yok)
  const totalBonus = list.reduce(
    (t, e) => t + Number(e.amount),
    0
  );

  setEarnings(list);

  setStats(s => ({
    ...s,
    withdrawable: sum("available"),
    pending: sum("pending"),
    totalProfit:
      sum("pending") + sum("available") + sum("paid"),
  }));
});

}, [token]);

  // ✅ KOŞULLU RETURN ARTIK DOĞRU YERDE
  if (!token) {
    return <AuthPage onAuth={() => window.location.reload()} />;
  }

// ✅ YENİSİ – DOĞRU YER
const applyPackage = async (paketAdi, paketFiyati) => {
  if (!token) {
    alert("Giriş gerekli");
    return;
  }

  // ✅ ÖNCE ONAY
  const ok = window.confirm(
    `"${paketAdi}" paketini almak istediğinize emin misiniz?`
  );

  if (!ok) return; // ❌ Hayır derse DUR

  try {
    const res = await fetch(
      "https://api.haymestasarim.com/api/admin/paket/basvuru",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          paket_adi: paketAdi,
          paket_fiyati: paketFiyati,
        }),
      }
    );

    const data = await res.json();

if (!res.ok) {
  alert(data?.message || "Başvuru yapılamadı");
  return;
}

// 🔥 Upgrade ise fark mesajı gelir
if (data?.message?.includes("Upgrade")) {
  alert(
    `🔄 ${data.message}\n\n` +
    `Kalan Gün: ${data.kalan_gun || 0}\n\n` +
    `Onay sonrası paket süresi 365 gün olarak yeniden başlayacaktır.`
  );
} else {
  alert("✅ Paket başvurunuz admin onayına gönderildi.");
}



  } catch {
    alert("Sunucu hatası");
  }
};

  return (



    <div style={styles.layout}>
      {/* SIDEBAR */}
      <aside style={styles.sidebar}>
        <div style={styles.brand}>
          <b>MesYat</b>
          <span>Dijital Çözümler</span>
        </div>

        <Menu label="Dashboard" a={active} v="dashboard" s={setActive} />
        <Menu label="Referans Kazançları" a={active} v="kazanc" s={setActive} />
        <Menu label="Ekibim" a={active} v="ekibim" s={setActive} />
        <Menu label="Ayarlar" a={active} v="ayarlar" s={setActive} />

<Menu
  label="Çıkış"
  a={active}
  v="logout"
  s={() => {
    localStorage.removeItem("user_token");
    window.location.reload();
  }}
/>
      </aside>

      {/* CONTENT */}
      <main style={styles.content}>
        {active === "dashboard" && (
          <>
            {/* STAT CARDS */}
            <div style={styles.grid}>
              <Card
                title="Çekilebilir Bakiye"
value={`${stats.withdrawable.toLocaleString()} TL`}
                badge="Mevcut"
                c1="#e8fff3"
                c2="#c7f9e9"
              />


             <Card
  title="Toplam Yatırım"
  value={`${stats.totalInvestment.toLocaleString()} TL`}
  badge="Aktif"
  c1="#eef5ff"
  c2="#dbeafe"
/>

              <Card
                title="Toplam Kazanç"
value={`${stats.totalProfit.toLocaleString()} TL`}
                badge="Kazanıldı"
                c1="#f5f3ff"
                c2="#ede9fe"
              />
      <div
  style={{
    ...styles.card,
    background: "linear-gradient(135deg, #ecfeff, #cffafe)",
  }}
>
  <div style={styles.cardTop}>
    <span>Referans Kodu</span>
<span
  style={{ ...styles.badge, cursor: "pointer" }}
  onClick={() => {
    const refLink = `https://panel.haymestasarim.com/#/dashboard?ref=${stats.refCode}`;

    if (navigator.share) {
      navigator.share({
        title: "MesYat Referans Daveti",
        text: "MesYat'a katılmak için referans linkim",
        url: refLink,
      });
    } else {
      navigator.clipboard.writeText(refLink);
      alert("Referans linki kopyalandı");
    }
  }}
>
  Paylaş
</span>
  </div>

  <div style={styles.cardValue}>
  {stats.refCode || "—"}
</div>

<button
  style={{
    marginTop: 14,
    padding: "10px 18px",
    borderRadius: 999,
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer",
    fontWeight: 600,
  }}
  onClick={() => {
    navigator.clipboard.writeText(stats.refCode);
    alert("Referans kodu kopyalandı");
  }}
>
  Kopyala
</button>




</div>



<Card
  title="Bekleyen Talepler"
  value={`${stats.pending.toLocaleString()} TL`}
  badge="Onay"
  c1="#fefce8"
  c2="#fef9c3"
/>
   <Card
  title="Takım Sayısı"
  value={stats.teamCount}
  badge="Ekip"
  c1="#eef2ff"
  c2="#e0e7ff"
/>

         <Card
  title="Takım Hacmi"
  value={`${stats.teamVolume.toLocaleString()} TL`}
  badge="Hacim"
  c1="#fff1f2"
  c2="#ffe4e6"
/>
            </div>

          {/* YILLIK ABONELİK PAKETLERİ */}
<div style={styles.pricingBox}>
  <div style={styles.pricingHeader}>
    <h2>Yıllık Abonelik İhtiyaç Seçenekleri</h2>
    <p>Kurumunuzun büyüklüğüne göre en uygun paketi seçin</p>
  </div>

  <div style={styles.pricingGrid}>
  
<PricingCard
  title="Başlangıç Paketi"
  subtitle="100 üyeye kadar olan kulüpler"
  price="3.000 TL"
  color="#2563eb"
  bg="#eff6ff"
  features={[
    "Üye ve kayıt yönetimi",
    "Duyuru paylaşımı",
    "Etkinlik oluşturma",
    "Anket ve yoklama",
    "Geri bildirim toplama",
  ]}
  onApply={() => applyPackage("Başlangıç Paketi", 3000)}

/>

  <PricingCard
  title="Profesyonel Paket"
  subtitle="250 üyeye kadar"
  price="5.000 TL"
  color="#2563eb"
  bg="#eff6ff"
  popular
  features={[
    "Gelişmiş üye yönetimi",
    "Toplu duyuru & bildirim",
    "Etkinlik takvimi",
    "Detaylı anket modülü",
    "Geri bildirim ve raporlama",
  ]}
  onApply={() => applyPackage("Profesyonel Paket", 5000)}

/>

<PricingCard
  title="Kurumsal Paket"
  subtitle="500 üyeye kadar"
  price="8.000 TL"
  color="#2563eb"
  bg="#eff6ff"
  features={[
    "Merkezi üye yönetimi",
    "Kurumsal duyuru sistemi",
    "Çoklu etkinlik yönetimi",
    "Anket & analiz araçları",
    "Geri bildirim ve iletişim",
  ]}
  onApply={() => applyPackage("Kurumsal Paket", 8000)}

/>

    <PricingCard
  title="Premium Paket"
  subtitle="1000 üyeye kadar"
  price="10.000 TL"
  color="#2563eb"
  bg="#eff6ff"
  features={[
    "Detaylı üye yönetimi",
    "Gelişmiş duyuru & iletişim",
    "Büyük ölçekli etkinlikler",
    "Anket, analiz ve raporlama",
    "Öncelikli destek ve kullanım",
  ]}
  onApply={() => applyPackage("Premium Paket", 10000)}

/>

  </div>
</div>

          </>
        )}

{active === "kazanc" && <ReferansKazancPage />}
       {active === "ekibim" && <EkibimPage />}
{active === "ayarlar" && <ReferansAyarlar />}
      </main>
    </div>
  );
}

/* =====================================================
   COMPONENTS
===================================================== */

function PricingCard({
  title,
  subtitle,
  price,
  color,
  bg,
  popular,
  features,
  onApply,
}) {
  return (
  <div
  style={{
    ...styles.pricingCard,
    background: bg || "#ffffff",
    border: "1px solid #e5e7eb",
    transform: popular ? "scale(1.03)" : "none",
  }}
>
      {popular && <div style={styles.popularBadge}>En Popüler</div>}

      <h4 style={{ color }}>{title}</h4>
      <span style={styles.pricingSubtitle}>{subtitle}</span>

      <div style={styles.priceMain}>{price}</div>
      <div style={styles.priceSub}>Yıllık ödeme</div>

      <ul style={styles.pricingList}>
        {features.map((f, i) => (
          <li key={i} style={styles.featureItem}>
            <span style={styles.check}>✓</span>
            <span>{f}</span>
          </li>
        ))}
      </ul>

      {/* ✅ YENİ */}
      <button
        style={styles.pricingButton}
        onClick={onApply}
      >
        Pakete Başvur
      </button>
    </div>
  );
}



function Menu({ label, a, v, s }) {
  return (
    <div
      onClick={() => s(v)}
      style={{
        ...styles.menu,
background: a === v ? "#e0e7ff" : "transparent",
        fontWeight: a === v ? 600 : 400,
      }}
    >
      {label}
    </div>
  );
}

function Card({ title, value, badge, c1, c2 }) {
  return (
    <div
      style={{
        ...styles.card,
        background: `linear-gradient(135deg, ${c1}, ${c2})`,
      }}
    >
      <div style={styles.cardTop}>
        <span>{title}</span>
        <span style={styles.badge}>{badge}</span>
      </div>
      <div style={styles.cardValue}>{value}</div>
    </div>
  );
}

function Section({ title }) {
  return (
    <div style={styles.section}>
      <h2>{title}</h2>
      <p>Bu alan backend bağlantısından sonra aktif olacaktır.</p>
    </div>
  );
}

/* =====================================================
   STYLES
===================================================== */

const styles = {
  layout: { display: "flex", minHeight: "100vh", background: "#f8fafc" },

  sidebar: {
    width: 240,
    background: "#fff",
    borderRight: "1px solid #e5e7eb",
    padding: 24,
  },

  brand: {
    marginBottom: 30,
    fontSize: 18,
    display: "flex",
    flexDirection: "column",
  },

  menu: {
    padding: "10px 14px",
    borderRadius: 10,
    cursor: "pointer",
    marginBottom: 8,
    transition: "all .2s",
  },

  content: { flex: 1, padding: 32 },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
    gap: 20,
    marginBottom: 32,
  },

  card: {
    padding: 22,
    borderRadius: 16,
    boxShadow: "0 10px 30px rgba(0,0,0,.06)",
    transition: "transform .2s, box-shadow .2s",
  },

  cardTop: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 13,
    opacity: 0.8,
  },

  cardValue: { fontSize: 26, fontWeight: 700, marginTop: 10 },

  badge: {
    background: "#fff",
    padding: "4px 10px",
    borderRadius: 20,
    fontSize: 12,
  },

  tableBox: {
    background: "#fff",
    borderRadius: 16,
    padding: 24,
    boxShadow: "0 10px 30px rgba(0,0,0,.05)",
  },

  tableHeader: { marginBottom: 16 },

  table: { width: "100%", borderCollapse: "collapse" },

  rate: {
    background: "#ede9fe",
    padding: "4px 10px",
    borderRadius: 12,
    fontSize: 12,
  },

  section: {
    background: "#fff",
    padding: 40,
    borderRadius: 16,
    boxShadow: "0 10px 30px rgba(0,0,0,.05)",
  },

pricingBox: {
  background: "#fff",
  borderRadius: 20,
  padding: 32,
  boxShadow: "0 20px 40px rgba(0,0,0,.06)",
},

pricingHeader: {
  textAlign: "center",
  marginBottom: 32,
},

pricingGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
  gap: 24,
},

pricingCard: {
  position: "relative",
  border: "2px solid",
  borderRadius: 20,
  padding: 28,
  textAlign: "center",
  transition: "all .3s",
  maxWidth: "100%",        // ✅ EKLENDİ
},

popularBadge: {
  position: "absolute",
  top: -14,
  left: "50%",
  transform: "translateX(-50%)",
  background: "#111827",
  color: "#fff",
  padding: "6px 14px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 600,
},

pricingSubtitle: {
  display: "block",
  fontSize: 13,
  opacity: 0.7,
  marginBottom: 12,
},

pricingPrice: {
  fontSize: 28,
  fontWeight: 800,
  marginBottom: 20,
},

pricingYear: {
  fontSize: 14,
  fontWeight: 500,
},



pricingList: {
  listStyle: "none",
  padding: 0,
  marginBottom: 24,
  lineHeight: "1.9",
  fontSize: 14,
},



priceMain: {
  fontSize: 40,
  fontWeight: 700,
  textAlign: "center",
  marginBottom: 6,
},

priceSub: {
  fontSize: 14,
  color: "#6b7280",
  textAlign: "center",
  marginBottom: 24,
},

featureItem: {
  display: "flex",
  alignItems: "center",
  gap: 12,
  marginBottom: 14,
  fontSize: 15,
},

check: {
  width: 26,
  height: 26,
  borderRadius: "50%",
  background: "#eff6ff",
  color: "#2563eb",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
},

pricingButton: {
  marginTop: 20,
  display: "inline-block",
  padding: "14px 26px",
  borderRadius: 999,
  border: "2px solid #2563eb",
  color: "#2563eb",
  textDecoration: "none",
  fontWeight: 600,
},


};

/* =====================================================
   MOBILE RESPONSIVE OVERRIDE (DOKUNMAZ)
===================================================== */

if (typeof window !== "undefined") {
  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    styles.layout.flexDirection = "column";

    styles.sidebar.width = "100%";
    styles.sidebar.display = "flex";
    styles.sidebar.flexDirection = "row";
    styles.sidebar.overflowX = "auto";
    styles.sidebar.padding = 12;
    styles.sidebar.gap = 8;

    styles.brand.display = "none";

    styles.menu.marginBottom = 0;
    styles.menu.whiteSpace = "nowrap";

    styles.content.padding = 16;

    styles.grid.gridTemplateColumns = "1fr";
    styles.pricingGrid.gridTemplateColumns = "1fr";

    styles.pricingBox.padding = 18;
    styles.card.padding = 18;
    styles.pricingCard.padding = 20;
  }
}
